module.exports = __webpack_public_path__ + "img/5.45123dc8.png";